import type { ReactNode } from "react";

import { cn } from "../../utils";

export interface RadioGroupLabelProps {
  children?: ReactNode | string;
  className?: string;
}

export const Label = (props: RadioGroupLabelProps) => {
  return <p className={cn(props.className)}>{props.children}</p>;
};
